import { useCallback, useEffect, useState } from "react";
import {
  getLegacySessionInfo,
  getSessionInfo as getSessionInfoRequest
} from "./requests";
import { mapSessionInfoResponse } from "./mappers";
import { getCookie, setCookie } from "services/cookies";
import { clearAuthCookies, setUserToken } from "services/auth";
import { COOKIES } from "constants/cookies";

export const useSessionInfo = (initialState) => {
  const [sessionInfo, setSessionInfo] = useState(initialState);

  const getSessionInfo = useCallback(async (newToken) => {
    try {
      // get 'token' cookie if user was logged in on legacy pages
      const response = await getLegacySessionInfo();

      console.log("session info legacy");
      console.log(response);

      // clear all auth cookies if the current user was not logged in on legacy 'session_info' request
      if (!response.logged_in) {
        console.log("clear auth");
        clearAuthCookies();
      }
    } catch {
      console.log("session info catch");
      // do nothing
    } finally {
      console.log(newToken, !!newToken);
      const response = await getSessionInfoRequest();
      console.log("session info new");
      console.log(response);
      const formattedResponse = mapSessionInfoResponse(response);
      if (newToken) {
        setUserToken({ token: newToken });
      }

      setSessionInfo({ ...formattedResponse, isInitialLoading: false });
    }
  }, []);

  useEffect(() => {
    // set userUUID on cookies when necessary
    const hasUserUUIDCookie = !!getCookie(COOKIES.USER_UUID);
    if (hasUserUUIDCookie || !sessionInfo?.userID) return;

    setCookie({
      name: COOKIES.USER_UUID,
      value: sessionInfo?.userID,
      days: 28
    });
  }, [sessionInfo?.userID]);

  return {
    sessionInfo,
    getSessionInfo
  };
};
